
export interface ForgotPasswordDto
{
    getMsisdn(): string;
    getEncryptedPassword():string;
    getClientTxnId(): string;
    getOTP():string;
    getSecToc():string;
    getPassword(): string;
    getSecurityToken():string;
    setSecToc(secToc: string): void;
}

export class ForgotPasswordDtoImpl implements ForgotPasswordDto
{
    private msisdn: string;
    private encryptedPassword: string;
    private clientTxnId: string;
    private otp: string;
    private secToc: string;
    private password: string;
    private securityToken: string;

    getPassword(): string
    {
        return this.password;
    }

    getSecurityToken(): string {
        return this.securityToken;
    }
    setSecurityToken(securityToken: string): void
    {
        this.securityToken = securityToken;
    }
    setPassword(password: string)
    {
        this.password = password;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getEncryptedPassword(): string 
    {
        return this.encryptedPassword;
    }
    setEncryptedPassword(encryptedPassword: string)
    {
        this.encryptedPassword = encryptedPassword;
    }

    getClientTxnId(): string 
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    
    getOTP(): string 
    {
        return this.otp;
    }
    setOTP(otp: string)
    {
        this.otp = otp;
    }
    
    getSecToc(): string 
    {
        return this.secToc;
    }
    setSecToc(secToc: string)
    {
        this.secToc = secToc;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/forgotpassword/forgotpassworddto.tsx